/* The two lines under the footer's links, and where each one's facts come from.

   The copyright is not content. Its two facts are the operator's name, which
   the platform owns (`GET /site`), and the year, which the clock owns — the
   whitelabel's footer builds the same line the same way. It used to be a
   free-text field that shipped as "© 2026 Flipcoin.com", so every site the
   factory stamped out claimed to be Flipcoin until someone noticed.

   The licence text *is* content: the public API has no field for the legal
   entity, the registration or the licence number, so it is written at
   /admin -> Branding. What it must not do is bake the operator's name in, for
   the same reason — so it takes the name as a placeholder and the platform
   fills it. */

export const SITE_NAME_TOKEN = "{site}";

export const copyrightLine = (siteName: string, year: number) =>
  `© ${year} ${siteName} | All Rights Reserved.`;

export const fillSiteName = (text: string, siteName: string) =>
  text.replaceAll(SITE_NAME_TOKEN, siteName);
